export const FONT_SIZE_LEVELS = [
    { level: 0, scale: 0.8, name: 'X-Small' },
    { level: 1, scale: 0.9, name: 'Small' },
    { level: 2, scale: 1.0, name: 'Default' },
    { level: 3, scale: 1.1, name: 'Medium' },
    { level: 4, scale: 1.2, name: 'Large' },
    { level: 5, scale: 1.4, name: 'X-Large' },
];
export const BASE_FONT_SIZE_REM = 1;
//# sourceMappingURL=settings.js.map